import { useEffect, useState } from 'react'

import { useBreadcrumbsData } from '@percent/admin-dashboard/app/Layout/breadcrumbsContext/useBreadcrumbsData/useBreadcrumbsData'
import { useQuery, useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { APIErrorHandler } from '@percent/admin-dashboard/common/library/APIErrorHandler'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { EligibilityDetailsView } from './EligibilityDetailsView/EligibilityDetailsView'
import { Organisation } from '@percent/admin-dashboard/api/types'

export function EligibilityDetailsContainer() {
  const { id } = useRequiredParams()

  const { eligibilityService, adminService } = useServices()
  const { setPath } = useBreadcrumbsData()
  const [orgData, setOrgData] = useState<Organisation | null>(null)
  const [orgLoader, setOrgLoader] = useState(true)
  const [orgError, setOrgError] = useState('')

  const [
    { data: subscription, isLoading: isSubscriptionLoading, errorMessage: subscriptionErrorMessage },
    { refresh }
  ] = useQuery(eligibilityService.getSingleEligibilitySubscription, { id: id ?? '' })

  const getData = async (orgId: string) => {
    setOrgLoader(true)
    try {
      const {
        data: { data: oData }
      } = await adminService.getOrganisation({ id: orgId })

      setOrgData(oData)
      setOrgLoader(false)
    } catch (err) {
      setOrgError(APIErrorHandler(err?.response?.data?.error))
      setOrgLoader(false)
    }
  }

  useEffect(() => {
    if (subscription) {
      getData(subscription.organisationId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription])

  useEffect(() => {
    setPath(`${subscription?.organisationName}`)

    return () => setPath(undefined)
  }, [setPath, subscription])

  return (
    <EligibilityDetailsView
      errorMessage={orgError || subscriptionErrorMessage}
      isLoading={orgLoader || isSubscriptionLoading}
      orgData={orgData}
      subscription={subscription}
      refresh={refresh}
      partnerName={subscription?.partnerName ?? null}
    />
  )
}
